import { WebPlugin } from '@capacitor/core';

import type { LabelOptions, LpapiPluginPlugin, PrinterAddress, PrinterOptions, ShapeOptions, TextOptions } from './definitions';

export class LpapiPluginWeb extends WebPlugin implements LpapiPluginPlugin {

  async getPrinterState(): Promise<any> {
    return Promise.resolve();
  }

  async printText1DBarcode(options: PrinterOptions): Promise<any> {
    return options;
  }

  async printText(options: TextOptions): Promise<any> {
    return options;
  }

  async drawText1DBarcode(options: TextOptions): Promise<any> {
    return options;
  }

  async drawText(options: TextOptions): Promise<any> {
    return options;
  }

  async drawCircle(options: ShapeOptions): Promise<any> {
    return options;
  }

  async drawRect(options: ShapeOptions): Promise<any> {
    return options;
  }

  async drawLine(options: ShapeOptions): Promise<any> {
    return options;
  }

  async startJob(options: LabelOptions): Promise<any> {
    return options;
  }

  async abortJob(): Promise<any> {
    return Promise.resolve();;
  }

  async commitJob(): Promise<any> {
    return Promise.resolve();;
  }

  async disconnectPrinter(): Promise<any> {
    return Promise.resolve();
  }

  async connectPrinter(options: PrinterAddress): Promise<any> {
    return options;
  }

  async getPairedPrinters(): Promise<any> {
    return Promise.resolve();
  }

}
